import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { startPlanCheckoutOrLogin } from '../services/billingservice';
import LoginRequiredNotice from '../components/LoginRequiredNotice.jsx';
import ChatbotRoute from './ChatbotRoute'; // Import the actual Chatbot UI components!
import styles from '../style/ChatbotPage.module.css';

function ChatbotPage() {
    const { user, userProducts, plans } = useAuth();
    const navigate = useNavigate();

    // Secure plan check
    const hasChatbot = 
        !!plans?.chatbot?.active || 
        userProducts?.some(p => p.product_name === 'chatbot' && p.is_active);

    if (!user) {
        return (
            <LoginRequiredNotice 
                title="Melden Sie sich an, um den Chatbot zu nutzen"
                subtitle="Nach der Anmeldung können Sie den Chatbot-Plan kaufen und sofort starten."
            />
        );
    }

    const handlePurchasePlan = async (plan) => {
        try {
            await startPlanCheckoutOrLogin(plan, user, navigate);
        } catch (error) {
            console.error('Kauf fehlgeschlagen:', error);
        }
    };

    if (!hasChatbot) {
        return (
            <div className={styles.pageContainer} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '80vh', position: 'relative' }}>
                <div className={styles.decorativeBg} aria-hidden="true" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0 }}>
                    <svg width="100%" height="100%" viewBox="0 0 1440 600" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.bgSvg}>
                        <defs>
                            <linearGradient id="bg-gradient" x1="0" y1="0" x2="1" y2="1">
                                <stop offset="0%" stopColor="#eaf1fb" />
                                <stop offset="100%" stopColor="#c6d4e8" />
                            </linearGradient>
                            <radialGradient id="blob1" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                                <stop offset="0%" stopColor="#1c3a7a" stopOpacity="0.12" />
                                <stop offset="100%" stopColor="#058744" stopOpacity="0.08" />
                            </radialGradient>
                        </defs>
                        <ellipse cx="300" cy="120" rx="320" ry="120" fill="url(#blob1)" />
                        <ellipse cx="1200" cy="500" rx="260" ry="100" fill="url(#blob1)" />
                    </svg>
                </div>

                <section className={styles.needPlanBanner} style={{ position: 'relative', zIndex: 1, width: '100%', maxWidth: '600px', boxSizing: 'border-box' }}>
                    <div className={styles.sectionWrapper}>
                        <div className={styles.bannerContent} style={{ textAlign: 'center', padding: '2rem' }}>
                            <div className={styles.bannerIcon} style={{ fontSize: '3rem', marginBottom: '1rem' }}>🔒</div>
                            <div className={styles.bannerText}>
                                <h3>Sie benötigen einen aktiven Plan für den Chatbot-Service</h3>
                                <p style={{ margin: '1rem 0 2rem 0' }}>Starten Sie Ihre kostenlose 30-tägige Testphase, um alle Funktionen freizuschalten.</p>
                            </div>
                            <button className={styles.bannerButton} onClick={() => handlePurchasePlan('chatbot')}>
                                Kostenlose Testphase starten
                            </button>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    // Since the user is logged in AND has an active plan, we render the actual Chatbot!
    return (
        <div style={{ height: 'calc(100vh - 64px)', width: '100%' }}> 
            <ChatbotRoute />
        </div>
    );
}

export default ChatbotPage;